import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate } from "react-router-dom";
import DepartmentListComponent from "./component";

const CorporateDepartmentListContainer = (props) => {
  const { corporateId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [departmentList, setDepartmentList] = useState({ departments: [] });
  const [corporateName, setCorporateName] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (corporateId) {
      fetchData();
    }
  }, [corporateId]);

  const fetchData = () => {
    setLoading(true);
    setError(null);

    props.getDataFromAPI(
      `/partner/api/v1/corp/${corporateId}/details`,
      "GET",
      undefined,
      (response) => {
        console.log("API Response:", response);

        if (response && response.departments) {
          setCorporateName(response.corporateName || "Corporate");
          setDepartmentList({
            departments: response.departments || [],
          });
        } else if (Array.isArray(response)) {
          setCorporateName("Corporate");
          setDepartmentList({
            departments: response,
          });
        } else {
          setCorporateName("Corporate");
          setDepartmentList({ departments: [] });
        }

        setLoading(false);
      },
      (error) => {
        console.error("Error:", error);
        setError(error.message || "Failed to load departments");
        setCorporateName("Corporate");
        setDepartmentList({ departments: [] });
        setLoading(false);
      }
    );
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleDepartmentClick = (departmentId, department) => {
    console.log("Clicked:", departmentId, department);
  };

  const retryFetch = () => {
    fetchData();
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearch = () => {
    // optional (frontend search already working)
    console.log("Search:", searchValue);
  };

  return (
    <DepartmentListComponent
      loading={loading}
      error={error}
      departmentList={departmentList}
      corporateName={corporateName}
      handleBackClick={handleBackClick}
      handleDepartmentClick={handleDepartmentClick}
      retryFetch={retryFetch}
      searchValue={searchValue}
      handleSearchInputChange={handleSearchInputChange}
      handleSearch={handleSearch}
    />
  );
};

export default connect(null, { getDataFromAPI })(CorporateDepartmentListContainer);
